import React, { useEffect, useState, useCallback} from 'react';
import { Typography, Container, Divider, Box, CircularProgress, Pagination } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { obter_pedidos } from '../../services/peds-api.js';
import { useAuth } from "../../context/AuthContext.tsx";
import CardOrder from '../../components/CardOrder.tsx';
import { ptBR } from '@mui/x-date-pickers/locales';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/pt-br';

export interface Pedido {
  id: number;
  data: string;
  valor: number;
  status: 'Finalizado' | 'Cancelado' | 'Pendente';
  itens: string[];
}

const Historico = () => {
  const [pedidos, setPedidos] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [totalPagina, setTotalPagina] = useState(1);
  const [filtroData, setFiltroData] = useState<Dayjs | null>(dayjs()); // dayjs() = inicia com dia atual
  const { userData } = useAuth();
  const pageSize = 12;

  const carregarPedidos = useCallback(async () => {
    try {
      setCarregando(true);
      const dataParaBusca = filtroData ? filtroData.format('YYYY-MM-DD') : '';
      const res = await obter_pedidos(userData.clI_CODIGO, dataParaBusca,paginaAtual, pageSize);

      if(res.sucesso){
        setPedidos(res.lista_pedidos)
        setTotalPagina(res.paginacao.totalPaginas);
      } else {
        setPedidos([]);
        setTotalPagina(1);
      }
    } catch (error) {
      console.error("Erro ao carregar pedidos:", error);
    } finally {
      setCarregando(false);
    }
  }, [filtroData, paginaAtual, userData.clI_CODIGO])

  useEffect(() => {
    carregarPedidos();
  }, [carregarPedidos]);

  return (
    <Container maxWidth="xl">
      <Typography variant="h5" marginTop={4} marginBottom={2}>
        Histórico de Pedidos
      </Typography>
      
      <Divider/>

      <Box py={1.5}>
      <LocalizationProvider 
        dateAdapter={AdapterDayjs} 
        adapterLocale="pt-br" 
        localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
      >
        <DatePicker
          slotProps={{ textField: { size: 'small', sx: { width: 140 } } }}
          label="Filtro por data"
          format="DD/MM/YYYY"
          value={filtroData}
          onChange={(newValue) => {
            setPaginaAtual(1);           
            setFiltroData(newValue);
          }}
        />
      </LocalizationProvider>
      </Box>
      <Divider/>
      {carregando ? (
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      ) : pedidos.length === 0 ? (
        <Typography color="textSecondary">Nenhum pedido encontrado nos ultimos 30 dias.</Typography>
      ) : (
        <>
          {pedidos.map((pedido) => (
            <CardOrder pedido={pedido} key={pedido.capa.coD_PEDIDO}/>
          ))}

          <Box mt={3} display="flex" justifyContent="center">
            <Pagination 
              count={totalPagina}          
              page={paginaAtual}            
              onChange={(_, value) => setPaginaAtual(value)}
              color="primary" 
            />
          </Box>
        </>
      )}
    </Container>
  )
}

export default Historico
